interface ExternalLinkButtonProps {
    href: string;
    title: string;
    iconUrl: string;
    alt: string;
}

function ExternalLinkButton({href, title, iconUrl, alt}: ExternalLinkButtonProps) {
    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            title={title}
            className="icon-button"
        >
            <img
                src={iconUrl}
                alt={alt}
                className="icon-button-icon"
                style={{imageRendering: 'auto'}}
            />
        </a>
    );
}

export default ExternalLinkButton;
